import { GetTokenSilentlyOptions } from '@auth0/auth0-react';
import { parseJwt } from '~/helpers/decodeToken.helper';
import { getAuth0Audience } from '~/helpers/utils';
import { normalizeTokenClaims } from '~/contexts/AuthProvider';

let getAccessTokenSilently: (
  options?: GetTokenSilentlyOptions | undefined
) => Promise<string>;

export const accessToken = {
  get: () =>
    getAccessTokenSilently({
      authorizationParams: {
        audience: getAuth0Audience(),
      },
    }),
  getDecoded: async () => {
    const token = await getAccessTokenSilently({
      authorizationParams: {
        audience: getAuth0Audience(),
      },
    });
    const decoded = parseJwt(token);
    // Normalize token claims from both Auth0 and Cognito to a common format
    return normalizeTokenClaims(decoded);
  },
  set: (
    func: (options?: GetTokenSilentlyOptions | undefined) => Promise<string>
  ) => (getAccessTokenSilently = func),
};

/**
 * TOKEN constants - Updated to use normalized claim keys
 * These keys work with both Auth0 and Cognito tokens after normalization
 * Old Auth0 keys (e.g., 'https://mypages/email') are automatically normalized to these keys
 */
export const TOKEN = {
  EMAIL: 'email',
  SSN: 'ssn',
  MARKET: 'market',
  CLIENT_ID: 'clientId',
  USER_CODE: 'userCode',
  DATE_OF_BIRTH: 'dateOfBirth',
};
